import { connectColors } from '@/theme/colors';

const HorizontalLine = () => {
  return (
    <div
      style={{
        borderTop: `1px solid ${connectColors.core.gray[700]}`,
        width: '100%',
      }}
    />
  );
};
export default HorizontalLine;
